import { Typography, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CustomTableDays, ShiftsCellDays } from './DaysRow.styles';
import NotificationPanel from './components/NotificationPanel';
import { formatLocalDate } from '../../../../utils/dateUtils';

const DaysRow = ({ onClick, daysOfWeek, unassignedShiftsCount }) => {
  return (
    <CustomTableDays>
      {/* Badge and text "Need your attention". Hidden as it is not currently being used; saved for future development */}
      <NotificationPanel unassignedShiftsCount={unassignedShiftsCount} hidden={true} />

      {/* Mapping of the days of the week */}
      {daysOfWeek.map((day) => (
        <ShiftsCellDays key={day.day}>
          <div>
            <Typography variant="bodyEmphasized" sx={{ color: 'white', fontWeight: 600 }}>
              {day.day}
            </Typography>
            <Typography variant="bodyRegular" sx={{ color: 'white', whiteSpace: 'nowrap' }}>
              {formatLocalDate(day.date, {
                month: 'short',
                day: 'numeric',
              })}
            </Typography>
          </div>
          <span>
            <IconButton disabled={day.count > 0} onClick={(e) => onClick(e, day)}>
              <ArrowDropDownIcon />
            </IconButton>
          </span>
        </ShiftsCellDays>
      ))}
    </CustomTableDays>
  );
};

export default DaysRow;
